import React, { Component } from "react";
import { getWebsiteContent } from "../fetchJSON.js";
import { decode } from "he";

class AboutUs extends Component {
	constructor(props) {
		super(props);
		var bgClass = props.background === "dark" ? "special-row" : "";
		this.state = {
			welcome: null,
			ourDenomination: null,
			statementOfFaith: null,
			marriageStatement: null,
			vision: null,
			mission: null,
			backgroundClass: bgClass
		};
	}

	componentWillMount() {
		var that = this;

		getWebsiteContent("AboutUs", function (data) {
			that.setState({
				welcome: data[0].text,
				ourDenomination: data[1].text,
				statementOfFaith: data[2].text,
				marriageStatement: data[3].text,
				vision: data[4].text,
				mission: data[5].text
			});
		});
	}

	render() {
		var welcomeText = { __html: "<p>Loading...</p>" };
		var ourDenominationText = { __html: "<p>Loading...</p>" };
		var statementOfFaithText = { __html: "<p>Loading...</p>" };
		//var marriageStatementText = { __html: "<p>Loading...</p>" };
		var visionText = { __html: "<p>Loading...</p>" };
		var missionText = { __html: "<p>Loading...</p>" };

		if (this.state.welcome) {
			welcomeText = { __html: decode(this.state.welcome) };
		}
		if (this.state.ourDenomination) {
			ourDenominationText = { __html: decode(this.state.ourDenomination) };
		}
		if (this.state.statementOfFaith) {
			statementOfFaithText = { __html: decode(this.state.statementOfFaith) };
		}
		// if (this.state.marriageStatement) {
		// 	marriageStatementText = { __html: decode(this.state.marriageStatement) };
		// }
		if (this.state.vision) {
			visionText = { __html: decode(this.state.vision) };
		}
		if (this.state.mission) {
			missionText = { __html: decode(this.state.mission) };
		}

		return (
			<section id="about" className={`row padding100 ${this.state.backgroundClass}`}>
				<div className="container">
					{/*WELCOME to CRCK*/}
					<div dangerouslySetInnerHTML={welcomeText} />

					<hr />

					{/*<!--WHAT WE BELIEVE-->*/}
					<article className="row margin-top60">
						<h2 className="text-center">
							<strong>What We Believe</strong>
						</h2>
						<div className="toogle">
							<div className="toggle">
								<label className="text-center">Our Denomination (CRCA)</label>
								<div className="toggle-content">
									<div dangerouslySetInnerHTML={ourDenominationText} />
								</div>
							</div>
						</div>

						<div className="toggle">
							<label className="text-center">Statement of Faith</label>
							<div className="toggle-content">
								<div dangerouslySetInnerHTML={statementOfFaithText} />
							</div>
						</div>

						{/* <div className="toggle">
              <label className="text-center">Marriage</label>
              <div className="toggle-content">
                <div dangerouslySetInnerHTML={marriageStatementText} />
              </div>
            </div> */}
					</article>

					<hr />

					{/*Vision and Mission*/}
					<article className="row margin-top60">
						<h2 className="text-center">
							<strong>Vision and Mission</strong>
						</h2>
						<div>
							<div className="toogle">
								<div className="toggle">
									<label className="text-center">Vision</label>
									<div className="toggle-content">
										<div dangerouslySetInnerHTML={visionText} />
									</div>
								</div>

								<div className="toggle">
									<label className="text-center">Mission</label>
									<div className="toggle-content">
										<div dangerouslySetInnerHTML={missionText} />
									</div>
								</div>
							</div>
						</div>
					</article>
				</div>
			</section>
		);
	}
}

export default AboutUs;
